import { Box, Button as ButtonMaterial, Grid, IconButton } from '@mui/material';
import { INTEGERS_UNIT } from '../../../utils/regex';
import AutocompleteComponent from '../../../components/Autocomplete/Autocomplete';
import Button from '../../../components/Button/Button';
import DatePickerComponent from '../../../components/DatePicker';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import Input from '../../../components/Input/Input';
import UploadFileIcon from '@mui/icons-material/UploadFile';

function FormularioCarga(props: any) {
    const {
        handleUpload,
        data,
        errors,
        inputTypeDocOptions,
        loadingEnabledDocs,
        fetchingEnabledDocs,
        handleChange,
        handleCancelUpload
    } = props;

    const InputLabel = ({ title, value }: { title: string; value: any }) => {
        return (
            <p>
                {title} {value ? <span style={{ color: '#ff0000' }}>*</span> : ''}
            </p>
        );
    };

    return (
        <Box mt={3}>
            <Grid
                container
                component="form"
                spacing={2}
                onSubmit={(event: any) => {
                    event.preventDefault();
                    handleUpload(data);
                }}
                sx={{
                    paddingRight: '12px',
                    '& p': {
                        fontWeight: 600,
                        margin: 0,
                        fontSize: '15px'
                    }
                }}
            >
                <Grid item xs={6}>
                    <p>
                        Tipo de documento a digitalizar <span style={{ color: '#ff0000' }}>*</span>
                    </p>
                    <AutocompleteComponent
                        value={data?.tipoDocumento || ''}
                        options={inputTypeDocOptions}
                        name="tipoDocumento"
                        required
                        label="Seleccionar documento"
                        onChange={(value: any) => {
                            handleChange({
                                target: {
                                    name: 'tipoDocumento',
                                    value: value
                                }
                            });
                        }}
                        loading={loadingEnabledDocs || fetchingEnabledDocs}
                    />
                </Grid>
                <Grid item xs={6} />

                {data?.tipoDocumento && (
                    <>
                        <Grid item xs={6}>
                            <InputLabel
                                value={
                                    data?.tipoDocumento?.requiereCuilCuit && !data?.cuilPropietario
                                }
                                title="CUIT"
                            />
                            <Input
                                value={data?.cuitPropietario || ''}
                                name="cuitPropietario"
                                onChange={(e: any) => {
                                    let value = e.target.value;
                                    if (
                                        (INTEGERS_UNIT.test(value) || value === '') &&
                                        value?.length < 20
                                    ) {
                                        handleChange({
                                            target: { name: 'cuitPropietario', value: value }
                                        });
                                    }
                                }}
                                fullWidth
                                disabled={!!data?.cuilPropietario}
                                required={
                                    data?.tipoDocumento?.requiereCuilCuit && !data?.cuilPropietario
                                }
                            />
                        </Grid>
                        <Grid item xs={6}>
                            <InputLabel
                                value={
                                    data?.tipoDocumento?.requiereCuilCuit && !data?.cuitPropietario
                                }
                                title="CUIL"
                            />
                            <Input
                                value={data?.cuilPropietario || ''}
                                name="cuilPropietario"
                                onChange={(e: any) => {
                                    let value = e.target.value;
                                    if (
                                        (INTEGERS_UNIT.test(value) || value === '') &&
                                        value?.length < 20
                                    ) {
                                        handleChange({
                                            target: { name: 'cuilPropietario', value: value }
                                        });
                                    }
                                }}
                                fullWidth
                                disabled={!!data?.cuitPropietario}
                                required={
                                    data?.tipoDocumento?.requiereCuilCuit && !data?.cuitPropietario
                                }
                            />
                        </Grid>
                        <Grid item xs={6}>
                            <InputLabel
                                value={data.tipoDocumento?.requiereVencimiento}
                                title="Fecha de vencimiento"
                            />
                            <DatePickerComponent
                                value={data?.vencimiento || ''}
                                name="vencimiento"
                                label="Fecha de vencimiento"
                                setValue={(value: any) =>
                                    handleChange({
                                        target: {
                                            name: 'vencimiento',
                                            value: value
                                        }
                                    })
                                }
                                width="100%"
                                required={data.tipoDocumento?.requiereVencimiento}
                            />
                        </Grid>
                        <Grid item xs={6}>
                            <InputLabel
                                value={data.tipoDocumento?.requiereCustomId}
                                title="Referencia adicional"
                            />
                            <Input
                                fullWidth
                                value={data?.customId || ''}
                                name="customId"
                                onChange={handleChange}
                                required={data.tipoDocumento?.requiereCustomId}
                            />
                        </Grid>
                        <Grid
                            item
                            xs={6}
                            sx={{
                                '& .MuiButtonBase-root': {
                                    textTransform: 'none'
                                }
                            }}
                        >
                            <p>Documento a digitalizar</p>

                            <Box
                                sx={{
                                    fontSize: '12px',
                                    gap: '5px',
                                    display: 'grid',
                                    '& .MuiButton-endIcon': {
                                        position: 'absolute',
                                        right: '20px'
                                    }
                                }}
                                className="file-input"
                            >
                                <ButtonMaterial
                                    variant="outlined"
                                    component="label"
                                    startIcon={
                                        <UploadFileIcon
                                            sx={{ color: '#656565', fontSize: '24px' }}
                                        />
                                    }
                                    endIcon={
                                        <IconButton
                                            disabled={!data.selectedFile}
                                            sx={{
                                                visibility: data?.selectedFile
                                                    ? 'visible'
                                                    : 'hidden'
                                            }}
                                            onClick={() => {
                                                handleChange({
                                                    target: {
                                                        name: 'selectedFile',
                                                        value: null
                                                    }
                                                });
                                            }}
                                        >
                                            <HighlightOffIcon color="disabled" />
                                        </IconButton>
                                    }
                                    color="inherit"
                                    fullWidth
                                    aria-label="selectedFiles"
                                >
                                    <span
                                        style={{
                                            overflow: 'auto',
                                            whiteSpace: 'nowrap'
                                        }}
                                    >
                                        {data?.selectedFile
                                            ? data?.selectedFile?.name
                                            : 'Adjuntar Documento'}
                                    </span>
                                    <input
                                        name="selectedFile"
                                        type="file"
                                        value=""
                                        hidden
                                        onChange={(e: any) => {
                                            handleChange({
                                                target: {
                                                    name: 'selectedFile',
                                                    value: e?.target?.files[0],
                                                    type: 'file'
                                                }
                                            });
                                        }}
                                    />
                                </ButtonMaterial>
                                <span style={{ color: errors ? '#ff0000' : 'inherit' }}>
                                    {data?.tipoDocumento?.tiposArchivo
                                        ?.map((tipo: any) => tipo.extension)
                                        .join(', ')
                                        .toUpperCase()}
                                </span>
                            </Box>
                        </Grid>
                        <Grid item xs={6} />
                        <Grid
                            item
                            xs={12}
                            m={4}
                            display="flex"
                            justifyContent="flex-end"
                            gap="10px"
                        >
                            <Button type="outlined" onClick={handleCancelUpload}>
                                Cancelar
                            </Button>
                            <Button disabled={!!errors}>Guardar</Button>
                        </Grid>
                    </>
                )}
            </Grid>
        </Box>
    );
}

export default FormularioCarga;
